import { ApiSchema } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";
import { ExpenseCategoryFormData } from "@/formTypes/ExpenseCategoryDataType";

export type ExpenseCategoryDataType = Partial<ApiSchema["ExpenseCategory"]["type"] & ExpenseCategoryFormData>;
export const ExpenseCategoryApi = new GenericModelApi<"ExpenseCategory", ExpenseCategoryDataType>("ExpenseCategory", "title");